import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { mergeMap, catchError, of } from 'rxjs'
import { show_error_action, show_success_msg_after_updation_action } from '../action/common/common.action'
import { SettingsService } from '../../services/settings/settings.service'
import {
  fetch_company_setting_preferences_data,
  fetch_company_setting_preferences_data_success,
  update_settings_action,
  update_settings_success_action
} from '../action/settings.action'

@Injectable()
export class SettingsEffect {
  constructor(private actions$: Actions, private settingsService: SettingsService) {}

  fetch_company_setting_preferences_data$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_company_setting_preferences_data),
      mergeMap(action =>
        this.settingsService.invokeFetchCompanySettingPreferences(action.referenceId, action.referenceType).pipe(
          mergeMap(companySettingPreferences => [
            fetch_company_setting_preferences_data_success({ companySettingPreferences })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_company_settings_preferences_data$ = createEffect(() =>
    this.actions$.pipe(
      ofType(update_settings_action),
      mergeMap(({ referenceId, referenceType, settingsType, companySettingPreferences }) =>
        this.settingsService
          .callUpdateSettingsApi(referenceId, referenceType, settingsType, companySettingPreferences)
          .pipe(
            mergeMap(companySettingPreferences => [
              update_settings_success_action({ companySettingPreferences }),
              show_success_msg_after_updation_action({ moduleName: 'Settings' })
            ]),
            catchError((error: any) => of(show_error_action({ data: null, error: error })))
          )
      )
    )
  )
}
